import { supabase } from '../lib/supabase';

class MaterialRealtimeService {
  constructor() {
    this.subscription = null;
  }

  /**
   * Subscribe to real-time changes on materials table
   * @param {Function} onInsert - Callback when new material is inserted
   * @param {Function} onUpdate - Callback when material is updated
   * @param {Function} onDelete - Callback when material is deleted
   * @returns {Object} Subscription object
   */
  subscribeMaterials({ onInsert, onUpdate, onDelete }) {
    try {
      // Unsubscribe from existing subscription if any
      if (this.subscription) {
        this.unsubscribeMaterials();
      }

      // Create new subscription to materials table
      this.subscription = supabase
        ?.channel('materials-realtime-channel')
        ?.on(
          'postgres_changes',
          {
            event: 'INSERT',
            schema: 'public',
            table: 'materials'
          },
          (payload) => {
            console.log('Material inserted:', payload?.new);
            if (onInsert) onInsert(payload?.new);
          }
        )
        ?.on(
          'postgres_changes',
          {
            event: 'UPDATE',
            schema: 'public',
            table: 'materials'
          },
          (payload) => {
            console.log('Material updated:', payload?.new);
            if (onUpdate) onUpdate(payload?.new, payload?.old);
          }
        )
        ?.on(
          'postgres_changes',
          {
            event: 'DELETE',
            schema: 'public',
            table: 'materials'
          },
          (payload) => {
            console.log('Material deleted:', payload?.old);
            if (onDelete) onDelete(payload?.old);
          }
        )
        ?.subscribe((status) => {
          console.log('Materials realtime subscription status:', status);
        });

      return this.subscription;
    } catch (error) {
      console.error('Error subscribing to materials realtime:', error);
      return null;
    }
  }

  /**
   * Unsubscribe from materials table changes
   */
  unsubscribeMaterials() {
    try {
      if (this.subscription) {
        supabase?.removeChannel(this.subscription);
        this.subscription = null;
        console.log('Unsubscribed from materials realtime');
      }
    } catch (error) {
      console.error('Error unsubscribing from materials realtime:', error);
    }
  }
}

export default new MaterialRealtimeService();
